import { useState } from "react";
import { EmailSettings } from "./customPropertyConfig";
import { MySwitch } from "../../shared/MySwitch";

type AppCustomPropertySettingsEmailProps = {
    settings: EmailSettings
    onChange: (settings: EmailSettings) => void;
}

export const AppCustomPropertySettingsEmail = ({settings, onChange} : AppCustomPropertySettingsEmailProps) => {
    return (
        <div className="app-custom-property-settings-container">
            { }
        </div>
    )
}